﻿import { ApiCaller } from 'apis/ApiCaller';

export interface Country{
	Id: number;
	Name: string;
}

export interface State {
	Id: number;
	Name: string;
}

export class CountryApi {

    private static apiCaller = new ApiCaller('Country');

    public static GetAll() : Promise<Country[]> {

		    return this.apiCaller.GET<Country[]>('GetAll');

    }

    public static GetStates(countryId: number): Promise<State[]> {

	    return this.apiCaller.GET<State[]>('GetStates', { countryId });

    }

}